// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "style/" + chunkId + "." + {"154":"071d4a0bfe27fdba5e4d","481":"2c78da456df582d15921","815":"4161c713b81e95f4a008","918":"d7d7b6db32520eba38ff"}[chunkId] + ".css";
};